<template>
  <div>

    <div v-if="menuState === ''">
      <div v-if="userDetails">
        <!-- <button @click="logout">Logout</button>
        <h2>User Details</h2>
        <p>Name: {{ userDetails.name }}</p>
        <p>Email: {{ userDetails.email }}</p>
        <p>Profile Picture: <img :src="userDetails.picture" alt="Profile Picture"></p> -->
      </div>
      <!-- <button v-else @click="login">Login Using Google</button> -->
      <div v-else class="bg-gray-900 flex items-center justify-center min-h-screen">
        <button
          class="rounded-full w-64 h-12 mx-auto text-white border-2 border-green-500 flex items-center justify-center"
          @click="login()">
          <svg class="h-5 w-5 mr-2" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
            width="700px" height="700px" viewBox="-0.5 0 48 48" version="1.1">
            <title>Google-color</title>
            <desc>Created with Sketch.</desc>
            <defs> </defs>
            <g id="Icons" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="Color-" transform="translate(-401.000000, -860.000000)">
                <g id="Google" transform="translate(401.000000, 860.000000)">
                  <path
                    d="M9.82727273,24 C9.82727273,22.4757333 10.0804318,21.0144 10.5322727,19.6437333 L2.62345455,13.6042667 C1.08206818,16.7338667 0.213636364,20.2602667 0.213636364,24 C0.213636364,27.7365333 1.081,31.2608 2.62025,34.3882667 L10.5247955,28.3370667 C10.0772273,26.9728 9.82727273,25.5168 9.82727273,24"
                    id="Fill-1" fill="#FBBC05"> </path>
                  <path
                    d="M23.7136364,10.1333333 C27.025,10.1333333 30.0159091,11.3066667 32.3659091,13.2266667 L39.2022727,6.4 C35.0363636,2.77333333 29.6954545,0.533333333 23.7136364,0.533333333 C14.4268636,0.533333333 6.44540909,5.84426667 2.62345455,13.6042667 L10.5322727,19.6437333 C12.3545909,14.112 17.5491591,10.1333333 23.7136364,10.1333333"
                    id="Fill-2" fill="#EB4335"> </path>
                  <path
                    d="M23.7136364,37.8666667 C17.5491591,37.8666667 12.3545909,33.888 10.5322727,28.3562667 L2.62345455,34.3946667 C6.44540909,42.1557333 14.4268636,47.4666667 23.7136364,47.4666667 C29.4455,47.4666667 34.9177955,45.4314667 39.0249545,41.6181333 L31.5177727,35.8144 C29.3995682,37.1488 26.7323182,37.8666667 23.7136364,37.8666667"
                    id="Fill-3" fill="#34A853"> </path>
                  <path
                    d="M46.1454545,24 C46.1454545,22.6133333 45.9318182,21.12 45.6113636,19.7333333 L23.7136364,19.7333333 L23.7136364,28.8 L36.3181818,28.8 C35.6879545,31.8912 33.9724545,34.2677333 31.5177727,35.8144 L39.0249545,41.6181333 C43.3393409,37.6138667 46.1454545,31.6490667 46.1454545,24"
                    id="Fill-4" fill="#4285F4"> </path>
                </g>
              </g>
            </g>
          </svg>
          <span>Continue with Google</span>
        </button>
        <div v-if="connectData.isLoading" class="flex items-center justify-center w-full h-full bg-gray-800 absolute">
          <svg class="w-10 h-10 text-blue-500 animate-spin" xmlns="http://www.w3.org/2000/svg" fill="none"
            viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
          </svg>
        </div>
      </div>
    </div>
    <!--  -->
    <div v-if="menuState === 'errorConnectUser'">
      <div class="bg-gray-900 flex items-center justify-center min-h-screen">
        <h2 class="text-blue-500 text-6xl text-center p-4">You are already connected on another device</h2>
      </div>
    </div>
    <!--  -->
    <div v-else-if="menuState === 'connect'">
      <div class="bg-gray-900 flex items-center justify-center min-h-screen">
        <div class="text-center my-4">
          <!-- <div class="flex mb-4 items-center justify-center">
            <img :src="userDetails.picture" alt="Profile Picture" class="w-8 h-8 rounded-full mr-2">
            <div class="text-white text-sm">{{ userDetails.name }}</div>
            <button @click="toHome()" class="text-white text-sm">Logout</button>
          </div> -->
          <div v-if="controller != '0'">
            <div class="mb-4">
              <div
                class="flex items-center justify-center bg-gray-800 border-2 border-blue-500 rounded-lg w-64 h-16 mx-auto">
                <div class="w-10 h-10 flex items-center justify-center mr-4 pl-4">
                  <font-awesome-icon :icon="['fas', 'plug']" class="text-green-500 text-2xl" />
                </div>
                <input type="number" placeholder="Input Code"
                  class="rounded-lg bg-gray-800 text-white placeholder-gray-400 text-xl w-full h-full pr-4 focus:outline-none"
                  v-model="connectData.code">
              </div>
            </div>
            <div class="grid grid-cols-3 gap-4 place-items-center">
              <button @click="handleNumberClick('1')"
                class="bg-gray-800 text-white text-2xl w-16 h-16 rounded-full shadow-lg flex items-center justify-center">1</button>
              <button @click="handleNumberClick('2')"
                class="bg-gray-800 text-white text-2xl w-16 h-16 rounded-full shadow-lg flex items-center justify-center">2</button>
              <button @click="handleNumberClick('3')"
                class="bg-gray-800 text-white text-2xl w-16 h-16 rounded-full shadow-lg flex items-center justify-center">3</button>
              <button @click="handleNumberClick('4')"
                class="bg-gray-800 text-white text-2xl w-16 h-16 rounded-full shadow-lg flex items-center justify-center">4</button>
              <button @click="handleNumberClick('5')"
                class="bg-gray-800 text-white text-2xl w-16 h-16 rounded-full shadow-lg flex items-center justify-center">5</button>
              <button @click="handleNumberClick('6')"
                class="bg-gray-800 text-white text-2xl w-16 h-16 rounded-full shadow-lg flex items-center justify-center">6</button>
              <button @click="handleNumberClick('7')"
                class="bg-gray-800 text-white text-2xl w-16 h-16 rounded-full shadow-lg flex items-center justify-center">7</button>
              <button @click="handleNumberClick('8')"
                class="bg-gray-800 text-white text-2xl w-16 h-16 rounded-full shadow-lg flex items-center justify-center">8</button>
              <button @click="handleNumberClick('9')"
                class="bg-gray-800 text-white text-2xl w-16 h-16 rounded-full shadow-lg flex items-center justify-center">9</button>
              <button @click="handleDelete()"
                class="bg-gray-800 text-red-500 text-2xl w-16 h-16 rounded-full shadow-lg flex items-center justify-center">
                <font-awesome-icon :icon="['fas', 'times']" />
              </button>
              <button @click="handleNumberClick('0')"
                class="bg-gray-800 text-white text-2xl w-16 h-16 rounded-full shadow-lg flex items-center justify-center">0</button>
              <button @click="joinRoom()"
                class="bg-gray-800 text-green-500 text-2xl w-16 h-16 rounded-full shadow-lg flex items-center justify-center">
                <font-awesome-icon :icon="['fas', 'check']" />
              </button>
            </div>
          </div>
          <div v-if="controller != '0'" class="mt-10 mb-3 text-white text-sm">Don't have any code to connect?</div>
          <div v-if="!isGameOneDirect || controller === '0'">
            <button class="rounded-full w-64 h-12 mx-auto text-white border-2 border-green-500"
              @click="createRoom()">Create Room
            </button>
          </div>
        </div>
      </div>
      <!-- left arrow -->
      <button class="fixed top-4 left-4 p-2 rounded-full" @click="toHome()">
        <font-awesome-icon :icon="['fas', 'chevron-left']" class="w-6 h-6 text-white" />
      </button>
      <!-- right arrow -->
      <div class="fixed top-4 right-4 p-2 rounded-full flex items-center justify-center">
        <font-awesome-icon :icon="['fas', 'user']" class="text-green-500 text-1xl" />
        <p class="text-white text-1xl ml-2">{{ userCount }}</p>
      </div>
    </div>
    <!--  -->
    <div v-else-if="menuState === 'play'">
      <!-- <audio v-for="(streamData, index) in playData.remoteStreams" :key="index" :srcObject="streamData.stream" autoplay></audio> -->
      <div class="bg-gray-800 text-white">
        <div class="flex flex-col items-center justify-center h-screen overflow-hidden">
          <!-- Main Content -->

          <div class="relative flex-grow flex items-center justify-center w-full h-full">
            <div class="relative w-full h-full overflow-hidden flex items-center justify-center">
              <iframe v-if="playData.launcherUrl" :src="playData.launcherUrl" frameborder="0" ref="iframeGame"
                class="w-full h-full overflow-hidden" allowfullscreen>
              </iframe>
              <iframe v-if="playData.gameUrl" :src="playData.gameUrl" frameborder="0"
                class="w-full h-full overflow-hidden absolute" allowfullscreen>
              </iframe>
              <div v-if="playData.isLoading"
                class="flex items-center justify-center w-full h-full bg-gray-800 absolute">
                <svg class="w-10 h-10 text-blue-500 animate-spin" xmlns="http://www.w3.org/2000/svg" fill="none"
                  viewBox="0 0 24 24">
                  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                  <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
                </svg>
                <div v-if="isGameOneDirect" class="ml-2 text-xl">{{ playData.loading }}%</div>
              </div>
              <div class="absolute top-0 left-0 p-2">
                <button class="bg-gray-900 text-white px-2 py-1 rounded" @click="copyRoomIdButton()">
                  <font-awesome-icon :icon="['fas', 'copy']" class="mr-1" />
                  {{ connectData.code }}
                  <!-- <div v-for="(streamData, index) in playData.remoteStreams" :key="index" :srcObject="streamData.stream" autoplay>{{ index }}</div> -->
                </button>
              </div>
            </div>
          </div>
          <div v-if="(!isGameOneDirect) || (isGameOneDirect && controller === '1')" class="pb-11 md:pb-24">
          </div>
          <!-- Bottom Bar -->
          <div v-if="!isGameOneDirect"
            class="sticky-bottom-bar w-full flex flex-col md:flex-row items-center justify-center p-2 bg-gray-900 overflow-hidden md:h-24">
            <div v-if="playData.buttons[0].isActive"
              class="swiper-container overflow-y-auto mb-2 md:mb-0 custom-scroll">
              <div class="swiper-wrapper items-center md:justify-start justify-center">
                <!-- <div v-for="(user, index) in playData.users" :key="user.id"> -->
                <div v-for="(user, sub, index) in playData.users" :key="sub">
                  <div
                    :class="['swiper-slide', playData.colorUsers[index].class, 'w-16', 'h-16', 'rounded-lg', 'flex', 'items-center', 'justify-center', 'mx-2', 'overflow-hidden']">
                    <img :alt="user.name" class="rounded-full" height="50"
                      :style="{ borderWidth: user.voiceLevel + 'px', borderStyle: 'solid', borderColor: 'currentColor' }"
                      :src="'https://api.dicebear.com/9.x/pixel-art/png?seed=' + user.sub" width="50" />
                    <div v-if="user.download > 0 && user.download < 100"
                      class="bg-gray-900 bg-opacity-50 w-full absolute bottom-0 flex items-center justify-center"
                      :style="{ height: user.download + '%' }">{{ user.download }}%
                    </div>
                    <div v-if="user.warn === 1"
                      class="bg-gray-900 bg-opacity-50 w-full absolute bottom-0 flex items-center justify-center text-3xl"
                      :style="{ height: 100 + '%' }"><font-awesome-icon :icon="['fas', 'exclamation-triangle']" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="flex items-center justify-center pl-2">
              <button class="bg-gray-900 py-2 px-6 rounded-fulll w-8 h-8 flex items-center justify-center"
                @click="playData.buttons[0].isActive = !playData.buttons[0].isActive">
                <font-awesome-icon :icon="['fas', (playData.buttons[0].isActive ? 'users' : 'users-slash')]"
                  :class="(playData.buttons[0].isActive ? 'text-white' : 'text-gray-600')" />
              </button>
              <button class="bg-gray-900 py-2 px-6 rounded-full w-8 h-8 flex items-center justify-center"
                @click="togglePlayDataButton(1)">
                <font-awesome-icon :icon="['fas', (playData.buttons[1].isActive ? 'microphone' : 'microphone-slash')]"
                  :class="(playData.buttons[1].isActive ? 'text-white' : 'text-gray-600')" />
              </button>
              <button class="bg-gray-900 py-2 px-6 rounded-fulll w-8 h-8 flex items-center justify-center"
                @click="toConnect()">
                <font-awesome-icon :icon="['fas', 'phone']" />
              </button>
            </div>
          </div>
          <div v-if="isGameOneDirect && controller === '1'"
            class="sticky-bottom-bar w-full flex flex-col md:flex-row items-center justify-center p-2 bg-gray-900 overflow-hidden md:h-24">
            <div class="flex items-center justify-center pl-2">
              <button class="bg-gray-900 py-2 px-6 rounded-fulll w-8 h-8 flex items-center justify-center"
                @click="toConnect()">
                <font-awesome-icon :icon="['fas', 'phone']" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--  -->
    <div v-if="!isFullScreen && menuState != ''">
      <button class="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-75 z-50"
        @click="requestFullScreen()">
        <h2 class="text-2xl font-lg mb-4 text-center text-white"><font-awesome-icon :icon="['fas', 'fingerprint']"
            class="mr-2" /> Tap to fullscreen</h2>
      </button>
    </div>
    <div v-if="isFullScreen && isEmptyPeerWebrtc && menuState == 'play'">
      <button class="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-75 z-50"
        @click="toConnect()">
        <h2 class="text-2xl font-lg mb-4 text-center text-yellow-500"><font-awesome-icon
            :icon="['fas', 'exclamation-triangle']" class="mr-2" /> Tap to reconnect</h2>
      </button>
    </div>
  </div>
</template>

<script>
import { googleSdkLoaded } from "vue3-google-login";
import { connectSocket, disconnectSocket, getSocket } from '../socket';
import { isReadyWebrtc, handleSignalWebrtc, setUsersWebrtc, setupLocalStreamWebrtc, endAudioCallWebrtc, getRemoteStreamsWebrtc, microphoneWebrtc, sendDownloadWebrtc, sendRealtimeWebrtc } from '../webrtc';
import Cookies from 'js-cookie';
import axios from "axios";

export default {
  data() {
    return {
      controller: -1,
      gameName: 'default',
      isGameOneDirect: false,
      isMobile: false,
      isFullScreen: true,
      isEmptyPeerWebrtc: false,
      userDetails: null,
      userCount: 0,
      userHost: "",
      menuState: "",//"", connect, play
      connectData: {
        code: '',
        isLoading: false
      },
      playData: {
        gameUrl: "",
        launcherUrl: "",
        isLoading: false,
        loading: 0,
        remoteStreams: {},
        buttons: [
          { isActive: true },
          { isActive: true },
          { isActive: true },
          { isActive: true }
        ],
        colorUsers: [
          { class: 'bg-blue-500' },
          { class: 'bg-pink-500' },
          { class: 'bg-orange-500' },
          { class: 'bg-purple-500' },
          { class: 'bg-yellow-500' },
          { class: 'bg-green-500' },
          { class: 'bg-indigo-500' },
          { class: 'bg-amber-500' },
        ],
        users: []
      }
    };
  },
  mounted() {
    document.title = "Multi Pemain";

    const params = new URLSearchParams(window.location.search);
    // if (params.has('controller')) {
    //   this.controller = params.get('controller');
    // }
    if (params.has('gamename')) {
      this.gameName = params.get('gamename');
      this.isGameOneDirect = true;
    }

    this.menuState = "";
    const userCookie = Cookies.get('user');
    if (userCookie) {
      this.fetchUserData(userCookie);
    }

    if (this.getDeviceType() == "Mobile") {
      this.isFullScreen = false;
      this.isMobile = true;
    }

    if (this.isGameOneDirect) {
      if (this.isMobile) {
        this.controller = '1';
      }
      else {
        this.controller = '0';
      }
    }

    // Menambahkan event listener untuk perubahan fullscreen
    document.addEventListener('fullscreenchange', this.checkFullScreen);
    document.addEventListener('mozfullscreenchange', this.checkFullScreen);
    document.addEventListener('webkitfullscreenchange', this.checkFullScreen);
    document.addEventListener('msfullscreenchange', this.checkFullScreen);

    window.addEventListener("message", this.handleMessageFromIframe);
  },
  beforeUnmount() {
    // Menghapus event listener saat komponen dihancurkan
    document.removeEventListener('fullscreenchange', this.checkFullScreen);
    document.removeEventListener('mozfullscreenchange', this.checkFullScreen);
    document.removeEventListener('webkitfullscreenchange', this.checkFullScreen);
    document.removeEventListener('msfullscreenchange', this.checkFullScreen);

    window.removeEventListener("message", this.handleMessageFromIframe);
  },
  methods: {
    handleMessageFromIframe(event) {
      // // Verifikasi sumber pesan
      if (event.origin !== "https://play.moutongstudio.web.id") {
        return; // Abaikan pesan jika bukan dari iframe yang diharapkan
      }
      if (event.data.func === "DownloadProgress") {
        if (this.webrtcIsReady()) {
          this.playData.loading = event.data.paramNum;
          this.webrtcSendDownload(event.data.paramNum);
        }
        //this.webrtcSendDownload(event.data.paramNum);
        // const socket = getSocket();
        // if(socket)
        // {
        //   this.setUserDownload(socket.id, event.data.paramNum);
        // }
      }
      else if (event.data.func === "LoadingGameCompleted") {
        this.LoadingGameCompleted();

        this.HostConnectChange2(this.userHost);
        this.MineConnectChange(this.userDetails.sub);

        this.MobileGameConnectChange();
      }
      else if (event.data.func === "PlayGame") {
        this.PlayGame(event.data.paramStr);
      }
      else if (event.data.func === "EndGame") {
        this.EndGame();
      }
      else if (event.data.func === "Sync") {
        //console.log('Sync', event.data.dataStr);
        this.webrtcSendRealtime(event.data.dataStr);
      }
      else if (event.data.func === "RequestUserList") {
        this.UserConnectListChange();
      }
      // Menangani pesan dari iframe
      // if (event.origin === "LoadingGameCompleted") {
      //   this.LoadingGameCompleted(); // Panggil fungsi yang diinginkan
      // }
      // console.log("Pesan dari iframe:", event.data);
      // if (event.data === "halo dari iframe") {
      //   this.myFunction(); // Panggil fungsi yang diinginkan
      // }
    },
    checkFullScreen() {
      if (this.getDeviceType() == "Mobile") {
        this.isFullScreen = !!(document.fullscreenElement ||
          document.mozFullScreenElement ||
          document.webkitFullscreenElement ||
          document.msFullscreenElement);
      }
    },
    login() {
      googleSdkLoaded(google => {
        google.accounts.oauth2
          .initCodeClient({
            client_id:
              "814080495241-qo6q87dfa2miloa7ac31cd39piq44ijl.apps.googleusercontent.com",
            scope: "email profile openid",
            callback: response => {
              if (response.code) {
                this.sendCodeToBackend(response.code);
              }
            }
          })
          .requestCode();
      });
    }
    , handleNumberClick(number) {
      this.connectData.code += number;
    },
    handleDelete() {
      this.connectData.code = this.connectData.code.slice(0, -1);
    },
    handleSubmit() {
      this.toPlay();
      //alert(`Code submitted: ${this.connectData.code}`);
    },
    getDeviceType() {
      const userAgent = navigator.userAgent;
      if (/Mobi|Android/i.test(userAgent)) {
        return 'Mobile';
      }
      return 'Desktop';
    },
    requestFullScreen() {
      const element = document.documentElement; // Target the whole document for fullscreen

      if (element.requestFullscreen) {
        element.requestFullscreen();
      } else if (element.mozRequestFullScreen) { // Firefox
        element.mozRequestFullScreen();
      } else if (element.webkitRequestFullscreen) { // Chrome, Safari, Opera
        element.webkitRequestFullscreen();
      } else if (element.msRequestFullscreen) { // IE/Edge
        element.msRequestFullscreen();
      }
    },
    async sendCodeToBackend(code) {
      try {
        const response = await axios.post(
          "https://oauth2.googleapis.com/token",
          {
            code,
            client_id:
              "814080495241-qo6q87dfa2miloa7ac31cd39piq44ijl.apps.googleusercontent.com",
            client_secret: "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",
            redirect_uri: "postmessage",
            grant_type: "authorization_code"
          }
        );
        const id_token = response.data.id_token;
        //const accessToken = response.data.access_token;
        //console.log(accessToken);
        //console.log(response.data);

        Cookies.set('user', id_token, { expires: 30 });//Cookies.set('user', accessToken, { expires: 30 });
        this.fetchUserData(id_token);
        //await this.fetchUserData(accessToken);
      } catch (error) {
        //console.error("Token exchange failed:", error.response.data);
      }
    },
    fetchUserData(id_token) {
      const parts = id_token.split(".");
      const payload = JSON.parse(atob(parts[1]));
      console.log(payload.name);
      this.userDetails = { name: payload.name, email: payload.email, sub: payload.sub };

      if (this.userDetails.sub) {
        this.toConnect();
      } else {
        this.toHome();
      }
    },
    // async fetchUserData(accessToken) {
    //   this.LoadingConnectBegin();
    //   try {
    //     // Fetch user details using the access token
    //     const userResponse = await axios.get(
    //       "https://www.googleapis.com/oauth2/v3/userinfo",
    //       {
    //         headers: {
    //           Authorization: `Bearer ${accessToken}`
    //         }
    //       }
    //     );

    //     if (userResponse && userResponse.data) {
    //       // Set the userDetails data property to the userResponse object
    //       this.userDetails = userResponse.data;
    //       this.toConnect();
    //     } else {
    //       // Handle the case where userResponse or userResponse.data is undefined
    //       //console.error("Failed to fetch user details.");
    //       this.toHome();
    //     }
    //   }
    //   catch (error) {
    //     this.toHome();
    //   }
    // },
    socketConn() {
      const socket = connectSocket();
      // Tambahkan event listener atau emit event
      socket.on('messageFromServer', (msg) => {
        console.log('Received from server:', msg);
      });

      socket.on('connect', () => {
        socket.emit('connectUser', this.userDetails.sub);
      });

      socket.on('errorConnectUser', (message) => {
        this.toErrorConnectUser(message);
      });

      socket.on('userCount', (value) => {
        this.userCount = value;
      });

      socket.on('userList', (userList) => {
        const newList = userList;
        const oldList = this.playData.users;

        const oldIds = new Set(Object.values(oldList).map(u => u.sub));//new Set(oldList.map(u => u.sub));
        const newIds = new Set(Object.values(newList).map(u => u.sub));//new Set(newList.map(u => u.sub));

        this.HostConnectChange(oldList, newList);
        this.UserConnectChange(newList, oldIds);
        this.UserDisconnectChange(oldList, newIds);

        this.playData.users = newList;
        this.webrtcSetUsers(newList);
        console.log('userList:', newList);

        // if (this.isGameOneDirect) {//hanya untuk kondisi sementara, nanti di apply di projek lain
        //   if (this.GetObjectsCount(oldList) > 0 && this.GetObjectsCount(newList) > 0) {
        //     const oldHost = Object.values(oldList).find(user => user.isHost === true);
        //     const newHost = Object.values(newList).find(user => user.isHost === true);
        //     if (oldHost.sub != newHost.sub) {
        //       this.toConnect();
        //     }
        //   }
        // }
      });
    },
    socketDisconn() {
      disconnectSocket();
    },
    socketEvent(socket) {
      socket.on("connect_error", (err) => {
        console.error("❌ Connect error:", err.message);
        this.toConnect();
      });

      socket.on('error', (message) => {
        alert(message);
      });

      socket.on('errorJoinRoom', (message) => {
        this.socketDisconn();
        this.socketConn();
        alert(message);
      });

      // socket.on('userList', (userList) => {
      //   const newList = userList;
      //   const oldList = this.playData.users;

      //   const oldIds = new Set(Object.values(oldList).map(u => u.sub));//new Set(oldList.map(u => u.sub));
      //   const newIds = new Set(Object.values(newList).map(u => u.sub));//new Set(newList.map(u => u.sub));

      //   this.HostConnectChange(oldList, newList);
      //   this.UserConnectChange(newList, oldIds);
      //   this.UserDisconnectChange(oldList, newIds);

      //   this.playData.users = newList;
      //   console.log('userList:', newList);
      // });

      socket.on("signal", (data) => {
        handleSignalWebrtc(socket, data.signal, data.sender, () => {
          this.playData.remoteStreams = getRemoteStreamsWebrtc();
        });
      });
      // socket.on("user-disconnected", (userId)=>{
      //   removePeerConnectionWebrtc(userId);
      // });

      socket.on('joinedRoom', (roomId) => {
        this.connectData.code = roomId;
        this.toPlay();

        setupLocalStreamWebrtc(this.isGameOneDirect, socket, this.playData.users, (userId, voiceLevel) => {
          this.setUserVoice(userId, voiceLevel);
        }, (userId, val) => {
          this.setUserDownload(userId, val);
        }, (userId, val) => {
          this.setUserWarn(userId, val);
        }, (val) => {
          this.SendToIframe("sync", val);
        }
        // ,() => {
        //   //webrtc failed reconnect
        //   this.toConnect();
        // }
        , () => {
          //webrtc empty peer
          //this.isEmptyPeerWebrtc = true;
          this.toConnect();
        })
      });
    }
    ,
    setUserVoice(userId, voiceLevel) {
      const userData = Object.values(this.playData.users).find(user => user.id === userId);
      if (userData) {
        userData.voiceLevel = voiceLevel;
      }
    },
    setUserDownload(userId, val) {
      const userData = Object.values(this.playData.users).find(user => user.id === userId);
      if (userData) {
        userData.download = val;
      }
    },
    setUserWarn(userId, val) {
      const userData = Object.values(this.playData.users).find(user => user.id === userId);
      if (userData) {
        userData.warn = val;
      }
    },
    async createRoom() {
      const socket = getSocket();
      if (socket != null) {
        const userInfo = {
          id: socket.id,
          sub: this.userDetails.sub,
          name: this.userDetails.name,
          // voiceLevel: 0,
          // download: 0,
          isHost: false,
        };
        socket.emit('createRoom', userInfo);

        this.socketEvent(socket);
      }
    },
    async joinRoom() {
      if (this.connectData.code) {
        const socket = getSocket();
        if (socket != null) {
          const userInfo = {
            id: socket.id,
            sub: this.userDetails.sub,
            name: this.userDetails.name,
            voiceLevel: 0,
            download: 0,
            isHost: false
          };
          socket.emit('joinRoom', this.connectData.code, userInfo);

          this.socketEvent(socket);
        }
      } else {
        alert('Please enter a room name or create one');
      }
    },
    webrtcIsReady() {
      return isReadyWebrtc();
    },
    webrtcEndAudioCall() {
      endAudioCallWebrtc();
    },
    webrtcMicrophone(enabled) {
      microphoneWebrtc(enabled);
    },
    webrtcSendDownload(val) {
      sendDownloadWebrtc(val);
    },
    webrtcSendRealtime(val) {
      sendRealtimeWebrtc(val);
    },
    webrtcSetUsers(users) {
      setUsersWebrtc(users);
    }
    ,
    togglePlayDataButton(index) {
      this.playData.buttons[index].isActive = !this.playData.buttons[index].isActive;
      this.webrtcMicrophone(this.playData.buttons[index].isActive);
    },
    toPlay() {
      this.menuState = "play";
      this.playData.buttons[0].isActive = true;
      this.playData.buttons[1].isActive = false;
      this.PlayGame("");
      this.PlayLauncherGame("");
      if (!this.isGameOneDirect) {
        this.PlayLauncherGame("https://play.moutongstudio.web.id/data/launcher/?time=" + Date.now());
      }
      else {
        this.PlayLauncherGame("https://play.moutongstudio.web.id/data/" + this.gameName + "/?time=" + Date.now());
      }
    },
    toErrorConnectUser(message) {
      this.menuState = "errorConnectUser";
      this.connectData.code = "";
      this.playData.users = {};
      this.socketDisconn();
      console.log('error connect user', message);
    },
    toConnect() {
      this.menuState = "connect";
      this.connectData.code = "";
      this.playData.users = {};
      this.isEmptyPeerWebrtc = false;
      this.socketDisconn();
      this.socketConn();
      this.webrtcEndAudioCall();
      this.LoadingConnectCompleted();
    },
    toHome() {
      Cookies.remove('user');
      this.userDetails = null;
      this.menuState = "";
      this.socketDisconn();
      this.LoadingConnectCompleted();
    },
    testToConnect() {
      const socket = getSocket();
      if (socket != null) {
        socket.emit('testToConnect', this.connectData.code);
      }
    },
    copyRoomIdButton() {
      navigator.clipboard.writeText(this.connectData.code).then(() => {
        //alert('Text successfully copied to clipboard!');
      }).catch(err => {
        console.error('Failed to copy: ', err);
      });
    },
    PlayLauncherGame(url) {
      this.playData.launcherUrl = url;
      this.LoadingGameBegin();
    },
    PlayGame(url) {
      this.playData.gameUrl = url;
      this.LoadingGameBegin();
    },
    EndGame() {
      this.PlayGame("");
      this.LoadingGameCompleted();
    },
    SendToIframe(type, str) {
      const iframe = this.$refs.iframeGame;
      if (iframe && iframe.contentWindow) {
        iframe.contentWindow.postMessage({
          type: type,
          data: str
        }, "*");
      }
    }
    ,
    LoadingGameCompleted() {
      this.playData.isLoading = false;
      this.playData.loading = 0;
    }
    ,
    LoadingGameBegin() {
      this.playData.isLoading = true;
      this.playData.loading = 0;
    },
    LoadingConnectCompleted() {
      this.connectData.isLoading = false;
      this.playData.loading = 0;
    }
    ,
    LoadingConnectBegin() {
      this.connectData.isLoading = true;
    },
    UserConnectListChange() {
      const users = this.playData.users;

      if (this.GetObjectsCount(users) > 0) {
        let isIncludeHost = true;
        if (this.isGameOneDirect) {
          isIncludeHost = false;
        }
        const arrayUsers = [];
        for (const sub in users) {
          if (!isIncludeHost && users[sub].isHost) continue;
          arrayUsers.push(users[sub]);
        }
        this.SendToIframe("userList", JSON.stringify(arrayUsers));
      }
    }
    ,
    UserConnectChange(newList, oldIds) {
      const users = Object.values(newList).filter(u => !oldIds.has(u.sub));//newList.filter(u => !oldIds.has(u.sub));
      if (this.GetObjectsCount(users) > 0) {
        console.log('User list to unity:', users);
        for (const sub in users) {
          this.SendToIframe("userConnect", JSON.stringify(users[sub]));
        }
      }
    },
    UserDisconnectChange(oldList, newIds) {
      const users = Object.values(oldList).filter(u => !newIds.has(u.sub));//oldList.filter(u => !newIds.has(u.sub));
      if (this.GetObjectsCount(users) > 0) {
        console.log('User list to unity:', users);
        for (const sub in users) {
          this.SendToIframe("userDisconnect", JSON.stringify(users[sub]));
        }
      }
    },
    HostConnectChange(oldList, newList) {
      let finalUser = null;
      if (this.GetObjectsCount(oldList) > 0 && this.GetObjectsCount(newList) > 0) {
        const oldHost = Object.values(oldList).find(user => user.isHost === true);
        const newHost = Object.values(newList).find(user => user.isHost === true);
        if (oldHost.sub != newHost.sub) {
          finalUser = newHost;
        }
      }
      else {
        const newHost = Object.values(newList).find(user => user.isHost === true);
        finalUser = newHost;
      }
      if (finalUser) {
        this.HostConnectChange2(finalUser.sub);
        this.userHost = finalUser.sub;
        console.log('Host berubah:', finalUser);
      }
    },
    HostConnectChange2(host) {
      this.SendToIframe("hostConnect", host);
    },
    MineConnectChange(mineID) {
      this.SendToIframe("mineConnect", mineID);
    },
    MobileGameConnectChange() {
      if (this.isMobile) {
        this.SendToIframe("mobileConnect", 'any');
      }
    }
    ,
    GetObjectsCount(objects) {
      if (objects && typeof objects === 'object' && !Array.isArray(objects)) {
        return Object.values(objects).length;
      }
      return 0;
    }
  }
};
</script>
<style scoped>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
</style>